const $cache = {};

const initCache = () => {
    $cache.contentSlider = $(".content-plus-carousel");
    $cache.isSliderInit = $cache.contentSlider.find("img").length > 1;
    $cache.speed = $cache.contentSlider.data("speed") ? $cache.contentSlider.data("speed") : "3000";
    $cache.dots = $cache.contentSlider.data("dots") ? $cache.contentSlider.data("dots") : true;
    $cache.circleAnimation = $(".circle-animation");
};


const initEvents = () => {
    if ($cache.contentSlider.length > 0 && $cache.isSliderInit) {
        $cache.contentSlider.slick({
            infinite: true,
            mobileFirst: true,
            slidesToShow: 1,
            speed: 500,
            centerMode: false,
            fade: true,
            cssEase: "linear",
            autoplay: false,
            autoplaySpeed: $cache.speed,
            pauseOnHover: false,
            dots: $cache.dots,
            arrows: true,
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        dots: true
                    }
                }
            ]
        });
    }
};

export default function () {
    initCache();
    initEvents();
    $cache.circleAnimation.addClass("start");

    $cache.contentSlider.on("beforeChange", () => {
        $cache.circleAnimation.removeClass("start");
    });

    $cache.contentSlider.on("afterChange", () => {
        $cache.circleAnimation.addClass("start");
    });
}
